<template>
  <div>
    <v-container
      fill-height
      v-if="$store.state.menu.Tournaments"
      fluid
      grid-list-xl
    >
      <Loader :loading="loading" />
      <v-layout justify-center wrap>
        <v-flex md12>
          <material-card color="green" title="Список турниров" text="DTE">
            <v-btn
              color="primary"
              class="mr-2"
              @click="getTournaments(false)"
              text
            >
              Обновить
            </v-btn>


            <v-data-table
              :headers="headers"
              :items="TournamentsList"
              hide-actions
            >
              <template slot="headerCell" slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-success text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template slot="items" slot-scope="{ item }">
                <td class="text-xs-left">
                  {{ item.id }}
                </td>
                <td class="text-xs-left min-width">
                  {{ item.title }}
                </td>

                <td class="text-xs-left">
                  <span
                    class="text-warning"
                    v-if="item.is_active && item.is_active === 1"
                    >Да
                  </span>
                  <span class="text-warning" v-else>Нет </span>
                </td>

                <td class="text-xs-left">
                  <span v-if="item.created_at">{{
                    item.created_at | dateTime
                  }}</span>
                  <span v-else>Не указан еще</span>
                </td>
                <td class="text-xs-right min-width100">
                  <v-icon @click="openTournament(item.id)">mdi-pencil</v-icon>
                </td>
              </template>
            </v-data-table>

            <v-pagination
              v-if="last_page > 1"
              v-model="page"
              class="my-4"
              :length="last_page"
            ></v-pagination>
          </material-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog
      width="600"
      persistent
      transition="dialog-bottom-transition"
      v-model="TournamentAddModal"
    >
      <v-card>
        <v-card-text>
          <div class="body-2 mb-2">Название акции</div>
          <v-text-field
            v-model="Tournament_title"
            label="Введите модель"
            hide-details
          >
          </v-text-field>
          <br />
          <br />
        </v-card-text>
        <v-divider> </v-divider>
        <v-card-actions class="text-xs-center">
          <v-btn color="success" text @click="addTournament"
            >Добавить акцию
          </v-btn>
          <v-btn color="primary" text @click="TournamentAddModal = false"
            >Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      fullscreen
      hide-overlay
      v-if="TournamentID"
      v-model="TournamentID"
    >
      <TournamentCard
        :TournamentID="TournamentID"
        :closeTournament="closeTournament"
      />
    </v-dialog>
  </div>
</template>

<script>
import Loader from "../components/helper/Loader";

import { mapMutations, mapState } from "vuex";

import TournamentCard from "../components/TournamentCard";

export default {
  data: () => ({
    Tournament_title: "",
    TournamentAddModal: false,
    page: 1,
    searcher: null,
    loadingSearch: true,
    loading: true,
    last_page: 0,
    search: "",
    headers: [
      {
        sortable: false,
        text: "Номер акции",
        value: "id",
      },
      {
        sortable: false,
        text: "Название",
        value: "dealer.title",
      },
      {
        sortable: false,
        text: "Активен",
        value: "total",
      },
      {
        sortable: false,
        text: "Создание  акции",
        value: "created_at",
      },
      {
        sortable: false,
        text: "",
        value: "",
        align: "right",
      },
    ],
    TournamentsList: [],
    TournamentID: null,
  }),
  components: { TournamentCard, Loader },
  methods: {
    ...mapMutations(["SET_USER", "SET_BADGE_ORDERS"]),
    setOrders(val) {
      if (val) {
        this.getTournaments();
      }
    },
    getTournaments(noLoading) {
      if (!noLoading) this.loading = true;

      axios
        .get("admin/tournaments/list", {
          params: {
            per_page: 15,
            page: this.page,
            search: this.search,
          },
        })
        .then((response) => {
          this.TournamentsList = response.data.data;
          this.last_page = response.data.last_page;
        })
        .catch((error) => {})
        .finally(() => {
          this.loadingSearch = false;
          this.loading = false;
        });
    },
    openTournament(TournamentID) {
      console.log(TournamentID);
      this.TournamentID = TournamentID;
    },

    closeTournament(update) {
      if (update) {
        this.getTournaments(false);
      }
      this.TournamentID = null;
    },

    addTournament() {
      if (this.Tournament_title) {
        axios
          .post("admin/tournaments/set", {
            title: this.Tournament_title,
          })
          .then((response) => {
            if (response.data) {
              this.getTournaments(true);
              this.openTournament(response.data.id);
              this.Tournament_title = "";
            }
            this.$toast.success({
              title: "Успешно добавно",
              message: "Добавлена новая акция.",
            });
          })
          .catch((error) => {
            let data = error.response.data;
            if (data.errors) {
              let k = 0;
              Object.keys(data.errors).forEach((item) => {
                let err = data.errors[item];
                k++;
                for (let i = 0; i < err.length; i++) {
                  setTimeout(() => {
                    this.$toast.error({
                      title: "Ошибка",
                      message: err[i],
                    });
                  }, 100 * k);
                }
              });
            }
          })
          .finally(() => {
            this.loading = false;
            this.TournamentAddModal = false;
          });
      } else {
        this.$toast.error({
          title: "Заголовок",
          message: "Введите заголовок",
        });
      }
    },
  },
  watch: {
    search() {
      this.loadingSearch = true;
      clearTimeout(this.searcher);
      this.searcher = setTimeout(() => {
        this.page = 1;
        this.getTournaments(true);
      }, 1000);
    },
    page() {
      setTimeout(() => {
        this.getTournaments();
      }, 300);
    },
    language(val) {
      if (val) {
        this.getTournaments();
      }
    },
  },

  mounted() {
    this.getTournaments();
  },
  computed: {
    ...mapState(["language"]),
  },
};
</script>
